import { content } from "../../data/content";
import { Reveal, RevealLines } from "./Reveal";

export function Letter() {
  return (
    <section
      id="letter"
      data-testid="letter-section"
      className="relative w-full bg-lilac px-5 md:px-10 py-24 md:py-40"
    >
      <div className="max-w-2xl mx-auto">
        <Reveal>
          <p className="font-accent text-4xl md:text-6xl text-rose mb-10 md:mb-14">
            {content.letterGreeting}
          </p>
        </Reveal>

        <div className="space-y-7 md:space-y-9">
          {content.letterParagraphs.map((p, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <p className="font-body font-medium text-lg md:text-2xl leading-relaxed text-ink/90">
                {p}
              </p>
            </Reveal>
          ))}
        </div>

        <div className="mt-14 md:mt-20">
          <Reveal>
            <p className="font-body font-semibold text-lg md:text-xl text-ink/70">
              {content.letterSignoff}
            </p>
            <p className="font-accent text-5xl md:text-7xl text-grape mt-2 -rotate-3">
              {content.sender}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
